import { YandexUser } from '@/types/yandex';

export type DateEntry = {
  startDate: string;
  duration: string;
  startTime?: string;
};

export type FormValues = {
  taskKey: string;
  taskLabel: string;
  comment: string;
  users: YandexUser[];
  dateEntries: DateEntry[];
};

export const FormFields = {
  taskKey: 'taskKey',
  taskLabel: 'taskLabel',
  comment: 'comment',
  users: 'users',
  dateEntries: 'dateEntries',
} as const;

export type DataValues = {
  taskKey: string;
  duration: number;
  comment: string;
  startDate: string;
  usersIds: string[];
  eventUid?: string;
  eventRecurrenceId?: string | null;
};
